import api from "./ApiUrl";

const url = "tenant/v1/api";

export const getTenant = async (page, size, search) => {
  const params = { page, size };

  if (search) {
    params.search = search;
  }

  const res = await api.get(`${url}/tenant`, { params });
  return res.data;
};

export const getRegisterTenant = async (page, size, search) => {
  const params = { page, size };

  if (search) {
    params.search = search;
  }

  const res = await api.get(`${url}/tenant/subscription/Registered`, {
    params,
  });
  return res.data;
};

export const getTenantPaymentGatewayByTenantId = async (tenantId) => {
  const res = await api.get(`${url}/tenant/payment/config/${tenantId}`);
  return res.data;
};

export const saveTenantRazorpayGateway = async (payload) => {
  const res = await api.post(`${url}/tenant/payment/config`, payload);
  return res.data;
};

export const saveTenantCCAvenueGateway = async (payload) => {
  const res = await api.post(`${url}/tenant/ccAvenue/payment/config`, payload);
  return res.data;
};

export const updateTenantGatewayStatus = async (tenantId) => {
  const res = await api.post(`${url}/tenant/payment/config/status/${tenantId}`);
  return res.data;
};

export const approveTenant = async (data) => {
  const res = await api.put(`${url}/tenant/subscription/approved`, data);
  return res.data;
};

export const createTenantSubscription = async (data) => {
  const res = await api.post(`${url}/tenant/subscription`, data);
  return res.data;
};

export const getTenantPackage = async () => {
  const res = await api.get(`${url}/public/tenant/subscription/enum`);
  return res.data;
};

export const createTenant = async (data) => {
  const res = await api.post(`${url}/tenant`, data);
  return res.data;
};

export const createRazorpayData = async (data) => {
  const res = await api.post(`${url}/tenant/payment/config`, data);
  return res.data;
};

export const getRazorpayData = async (tenantId) => {
  const res = await api.get(`${url}/tenant/payment/config/${tenantId}`);
  return res.data;
};

export const updateTenant = async (tenantId, data) => {
  const res = await api.put(`${url}/tenant/${tenantId}`, data);
  return res.data;
};

export const getTimeZone = async () => {
  const res = await api.get(`${url}/public/timezones`);
  return res.data;
};

export const mapUserWithTenant = async (data) => {
  const res = await api.post(`${url}/users/tenant`, data);
  return res.data;
};

// export const getTenantUser = async (params = {}) => {
//   const res = await api.get(`${url}/users/search/`, { params });
//   return res.data;
// };

export const getTenantUser = async (pageOrParams, size, search) => {
  const isObjectParams =
    pageOrParams !== null &&
    typeof pageOrParams === "object" &&
    !Array.isArray(pageOrParams);

  const resolvedPage = isObjectParams ? pageOrParams.page : pageOrParams;
  const resolvedSize = isObjectParams ? pageOrParams.size : size;
  const resolvedSearch = isObjectParams ? pageOrParams.search : search;

  const params = {};

  if (resolvedPage !== undefined && resolvedPage !== null) {
    params.page = resolvedPage;
  }

  if (resolvedSize !== undefined && resolvedSize !== null) {
    params.size = resolvedSize;
  }

  if (resolvedSearch !== undefined && resolvedSearch !== null) {
    params.search = resolvedSearch;
  }

  const res = await api.get(`${url}/users/search/`, {
    params,
  });
  return res.data;
};

export const getTenantByUserId = async (id, search) => {
  const params = {};
  if (search && search.trim() !== "") {
    params.search = search.trim();
  }
  const res = await api.get(`${url}/users/${id}/tenant`, { params });
  return res.data;
};

export const getUserByTenantId = async (id, page, size, search, admin = true) => {
  const params = { page, size };
  if (search && search.trim() !== "") {
    params.search = search.trim();
  }
  if (admin !== undefined && admin !== null && admin !== "") {
    params.admin = admin;
  }
  const res = await api.get(`${url}/tenant/${id}/users`, { params });
  return res.data;
};

export const createTenantUser = async (data) => {
  const res = await api.post(`${url}/users`, data);
  return res.data;
};

export const forgetPassword = async (data) => {
  const res = await api.post(`${url}/users/resset-password`, data);
  return res.data;
};

//dashboard
export const getSADashboardSummary = async () => {
  const res = await api.get(`${url}/dashboard/summary`);
  return res.data;
};

// gatway congig superadmin

export const getSuperAdminPaymentGateway = async () => {
  const res = await api.get(`${url}/tenant/application/payment/config`);
  return res.data;
};

export const saveSuperAdminRazorpayGateway = async (payload) => {
  const res = await api.post(
    `${url}/tenant/application/payment/config`,
    payload,
  );
  return res.data;
};

export const saveSuperAdminCCAvenueGateway = async (payload) => {
  const res = await api.post(
    `${url}/tenant/application/ccAvenue/payment/config`,
    payload,
  );
  return res.data;
};

export const updateSuperAdminGatewayStatus = async (tenantId) => {
  const res = await api.post(
    `${url}/tenant/application/payment/config/status/${tenantId}`,
  );
  return res.data;
};


//bulk data upload 

export const uploadBulkExcel = async (file) => {
  const formData = new FormData();
  formData.append("file", file);

  try {
    const response = await api.post(`${url}/file/upload/excel`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    console.error("File upload failed:", error);
    throw error;
  }
};

export const uploadPlayerBulkData = async (tenantId, payload) => {
  const res = await api.post(
    `${url}/file/upload/player/${tenantId}`, payload,
  );
  return res.data;
};

export const uploadCoachBulkData = async (tenantId, payload) => {
  const res = await api.post(
    `${url}/file/upload/coach/${tenantId}`, payload,
  );
  return res.data;
};

export const uploadStaffBulkData = async (tenantId, payload) => {
  const res = await api.post(
    `${url}/file/upload/staff/${tenantId}`, payload,
  );
  return res.data;
};

export const removeUserTenatMappingByid = async (payload) => {
  const res = await api.put(`${url}/users/tenant/change/status`, payload);
  return res.data;
};